@if (isStreamMediaMaterial()) {
  <div class="participant-media-panel">
    @if (mediaUrl) {
      <div class="participant-media-toolbar">
        <button type="button" class="download-button" (click)="confirmDownload()" title="Download">
          <fa-icon [icon]="faDownload"></fa-icon>
        </button>
      </div>
    }
    <div class="participant-media-stage">
      @if (mediaUrl && !streamIsAudio) {
        <video class="participant-media-player" [src]="mediaUrl" controls playsinline></video>
      }
      @if (mediaUrl && streamIsAudio) {
        <audio class="participant-media-player participant-media-audio" [src]="mediaUrl" controls></audio>
      }
    </div>
  </div>
}

@if (!isStreamMediaMaterial()) {
  <div class="pdf-viewer">
    @if (pdfSrc; as src) {
      <ngx-extended-pdf-viewer
        #pdfViewer
        [src]="src"
        [(sidebarVisible)]="sidebarVisible"
        (formDataChange)="onFormChange()"
        (pageRendered)="delayedUpdateFormData()"
        [(formData)]="formData"
        [language]="language"
        pageViewMode="multiple"
        [spread]="spreadMode"
        [customToolbar]="additionalButtons"
        [textLayer]="true"
        class="pdf-viewer-content">
      </ngx-extended-pdf-viewer>
    }
    <ng-template #additionalButtons>
      <div id="toolbarViewer" style="background-color:#E8E8E8; padding: 10px 0">
        <div id="toolbarViewerLeft">
          <pdf-toggle-sidebar></pdf-toggle-sidebar>
        </div>
        <button class="download-button" (click)="confirmDownload()" title="Download">
          <fa-icon [icon]="faDownload"></fa-icon>
        </button>
        <div class="button-spacer"></div>
        <pdf-find-button [showFindButton]="true" [textLayer]="true" ></pdf-find-button>
        <pdf-search-input-field></pdf-search-input-field>
        <pdf-find-previous></pdf-find-previous>
        <pdf-find-next></pdf-find-next>
        <div class="button-spacer"></div>
        <pdf-paging-area></pdf-paging-area>
        <div class="button-spacer"></div>
        <div id="toolbarViewerRight">
          <pdf-zoom-toolbar ></pdf-zoom-toolbar>
          <div class="button-spacer"></div>
          <div class="pdf-view-mode-buttons">
            <button
              type="button"
              class="pdf-view-mode-btn"
              [class.active]="spreadMode === 'off'"
              (click)="setSinglePageView()"
              title="Single page view">
              <fa-icon [icon]="faSinglePage"></fa-icon>
              <span>Single</span>
            </button>
            <button
              type="button"
              class="pdf-view-mode-btn"
              [class.active]="spreadMode === 'even'"
              (click)="setDoublePageView()"
              title="Two-page spread">
              <fa-icon [icon]="faDoublePage"></fa-icon>
              <span>Double</span>
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
}

@if (modalOpen | async) {
  <app-modal [title]="modalTitle" [content]="modalContent" [okButtonValue]="modalOkButtonValue"
  [cancelButtonValue]="modalCancelButtonValue" [okButtonText]="modalOkButtonText" [cancelButtonText]="modalCancelButtonText"></app-modal>
}
